const configDe = {
  currentCountyCode: '',
  imageDirectoryPath: '',
};

const config = (() => {
  let tempConfig = {};

  if (typeof window === 'undefined') {
    // Don't proceed in Node.js context for the processTranslations Gulp task
    return false;
  }

  // window.EfConfig is declared as inline-script in project/Configuration/TypoScript/Setup/page.typoscript
  if (window.EfConfig) {
    tempConfig = Object.assign({}, configDe, window.EfConfig);
  }

  return tempConfig;
})();

export default config;
